import { useState, useCallback } from "react";

const STORAGE_KEY = "the99.offlineMode";

function readOfflineMode() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

/**
 * Manages the user-controlled offline mode toggle.
 * When forceOffline is true the app behaves as if there is no connectivity,
 * even if the device is actually online.
 */
export default function useOfflineMode() {
  const [forceOffline, setForceOfflineState] = useState(readOfflineMode);

  const setForceOffline = useCallback((value) => {
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {}
    setForceOfflineState(value);
  }, []);

  return { forceOffline, setForceOffline };
}
